<template>
	<div class="drag-and-drop" :class="className">
		<input :ref="refName" type="file" :id="id" :name="name" @change="onChange" :multiple="false" />
		<div class="value header 6">{{ value !== "" ? value : "DRAG AND DROP OR BROWSE" }}</div>
		<i class="mdi mdi-plus"></i>
	</div>
</template>

<script>
export default {
	name: "drag-and-drop",
	props: {
		refName: String,
		id: String,
		name: String,
		className: String,
	},
	data() {
		return {
			value: "",
		};
	},
	methods: {
		onChange() {
			const input = document.getElementById(this.id);
			if (input && input.files) {
				this.value = input.files[0].name;
			}
		},
	},
};
</script>

<style scoped lang="scss">
.drag-and-drop {
	position: relative;
	background: rgba(80, 205, 243, 0.1);
	border: 1px dashed #50cdf3;
	border-radius: 3px;
	cursor: pointer;
	padding: 0;
	height: 80px;
	align-items: center;
	text-align: center;
	display: flex;
	flex-direction: row;
	justify-content: center;

	&:hover {
		border-style: solid;
		cursor: pointer;
	}

	.value {
		// width: 80%;
		font-style: normal;
		font-weight: 500;
		font-size: 11px;
		line-height: 16px;
		letter-spacing: 0.1em;
		padding-left: 20px;
		color: var(--dark-gray);
		opacity: 0.5;
		pointer-events: none;
		user-select: none;
		text-transform: uppercase;
	}
	i {
		width: 20%;
		opacity: 0.5;
		pointer-events: none;
	}
	i.mdi.mdi-plus {
		color: var(--accent);
		opacity: 1;
		font-size: 35px;
	}

	input {
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(255, 0, 0, 0.185);
		opacity: 0;

		&:hover {
			cursor: pointer;
		}
	}
}
</style>